document.addEventListener('DOMContentLoaded', function () {
	const initVideoLightboxButtons = () => {
		// Find all buttons with video lightbox enabled
		const videoLightboxButtons = document.querySelectorAll(
			'.wp-block-button--video-lightbox .wp-block-button__link'
		);

		if (videoLightboxButtons.length === 0) {
			return;
		}

		videoLightboxButtons.forEach((button) => {
			// Remove any existing click handlers
			const newButton = button.cloneNode(true);
			button.parentNode.replaceChild(newButton, button);

			// Add new click handler
			newButton.addEventListener('click', function (e) {
				e.preventDefault();

				const videoUrl = this.getAttribute('href');

				if (!videoUrl) {
					return;
				}

				// Check if video component is available
				if (typeof window.initializeVideoComponent === 'function') {
					// If there's a global function available, use it
					const tempVideo = document.createElement('figure');
					tempVideo.classList.add('component-video');
					tempVideo.setAttribute('data-embed-url', videoUrl);
					window.initializeVideoComponent(tempVideo);
				} else {
					// Otherwise, create our own lightbox that mimics the video component
					openCustomVideoLightbox(videoUrl);
				}
			});
		});
	};

	// Custom video lightbox function that mimics the video component
	const openCustomVideoLightbox = (videoUrl) => {
		// Check if a lightbox already exists
		let videoLightbox = document.querySelector('.component-video-lightbox');

		if (!videoLightbox) {
			// Create the lightbox structure
			videoLightbox = document.createElement('div');
			videoLightbox.classList.add('bg-dark', 'component-video-lightbox');
			videoLightbox.setAttribute('role', 'dialog');
			videoLightbox.setAttribute('aria-modal', 'true');

			const videoLightboxContainer = document.createElement('div');
			videoLightboxContainer.classList.add(
				'component-video-lightbox__container'
			);

			const videoLightboxContent = document.createElement('div');
			videoLightboxContent.classList.add(
				'component-video-lightbox__content'
			);

			const videoLightboxCloseOverlay = document.createElement('button');
			videoLightboxCloseOverlay.classList.add(
				'component-video-lightbox__close-button-overlay'
			);
			videoLightboxCloseOverlay.setAttribute('role', 'button');
			videoLightboxCloseOverlay.setAttribute(
				'aria-label',
				'Close Lightbox'
			);

			const videoLightboxCloseButton = document.createElement('span');
			videoLightboxCloseButton.classList.add(
				'component-video-lightbox__close-button'
			);

			// Add close functionality
			const closeLightbox = () => {
				videoLightbox.classList.remove('visible');
				setTimeout(() => {
					videoLightbox.classList.remove('active');
					// Clear the content
					videoLightboxContent.innerHTML = '';
				}, 400);
			};

			videoLightboxCloseOverlay.addEventListener('click', closeLightbox);
			videoLightboxCloseButton.addEventListener('click', closeLightbox);

			// Add escape key handler
			const handleEscape = (e) => {
				if (e.key === 'Escape') {
					closeLightbox();
					document.removeEventListener('keydown', handleEscape);
				}
			};
			document.addEventListener('keydown', handleEscape);

			// Assemble the lightbox
			videoLightboxCloseOverlay.appendChild(videoLightboxCloseButton);
			videoLightboxContainer.appendChild(videoLightboxContent);
			videoLightbox.appendChild(videoLightboxContainer);
			videoLightbox.appendChild(videoLightboxCloseOverlay);
			document.body.appendChild(videoLightbox);
		}

		// Get the content container
		const videoLightboxContent = videoLightbox.querySelector(
			'.component-video-lightbox__content'
		);

		// Create the exact structure that the original video lightbox uses
		const videoWrapper = document.createElement('div');
		videoWrapper.classList.add('component-video-lightbox__video');
		videoWrapper.style.width = '100%';
		videoWrapper.style.height = '100%';

		const innerWrapper = document.createElement('div');
		innerWrapper.style.width = '100%';
		innerWrapper.style.height = '100%';

		// Create an iframe for the video
		const iframe = document.createElement('iframe');
		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('allowfullscreen', '');
		iframe.setAttribute(
			'allow',
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
		);
		iframe.setAttribute('width', '100%');
		iframe.setAttribute('height', '100%');

		// Convert YouTube URL to embed URL if necessary
		let embedUrl = videoUrl;
		if (videoUrl.includes('youtube.com/watch')) {
			const videoId = videoUrl.split('v=')[1]?.split('&')[0];
			if (videoId) {
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
			}
		} else if (videoUrl.includes('youtu.be/')) {
			const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
			if (videoId) {
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
			}
		} else if (videoUrl.includes('vimeo.com/')) {
			const videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
			if (videoId) {
				embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
			}
		}

		iframe.src = embedUrl;

		// Build the nested structure
		innerWrapper.appendChild(iframe);
		videoWrapper.appendChild(innerWrapper);
		videoLightboxContent.innerHTML = '';
		videoLightboxContent.appendChild(videoWrapper);

		// Show the lightbox
		videoLightbox.classList.add('active');
		setTimeout(() => {
			videoLightbox.classList.add('visible');
		}, 10);
	};

	// Initialize on page load
	initVideoLightboxButtons();

	// Re-initialize when new blocks are added in the editor
	if (window.wp && window.wp.data) {
		window.wp.data.subscribe(() => {
			setTimeout(initVideoLightboxButtons, 100);
		});
	}
});
